import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
function CountUp({
  value,
  isVisible
}: {
  value: string;
  isVisible: boolean;
}) {
  const [count, setCount] = React.useState(0);
  const numericValue = parseInt(value.replace(/\D/g, "")) || 0;
  const suffix = value.replace(/[0-9]/g, "");
  React.useEffect(() => {
    if (!isVisible) {
      setCount(0);
      return;
    }
    let startTime: number | null = null;
    const duration = 2000;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easing = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(easing * numericValue));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    const animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isVisible, numericValue]);
  return <>{isVisible ? `${count}${suffix}` : `0${suffix}`}</>;
}
const stats = [{
  value: "57+",
  label: "PLAYERS PLACED",
  description: "Our athletes have successfully advanced to Junior and NCAA programs across North America."
}, {
  value: "42",
  label: "LEAGUES SCOUTED",
  description: "Active scouting networks across the USHL, NAHL, BCHL, and Canadian Major Junior."
}, {
  value: "94%",
  label: "ADVANCEMENT RATE",
  description: "The majority of players in our advisory program reach their primary development goals within two seasons."
}];
export default function KeyStatistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="30864" id="statistics" ref={ref} className="bg-background text-foreground w-full py-24 md:py-[120px]">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className={cn("grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
          {stats.map((stat, index) => <div key={index} data-index={index} className="flex flex-col items-center text-center bg-card/80 backdrop-blur-md border border-border hover:border-primary hover:shadow-[0_0_20px_-5px_var(--color-primary)] transition-all duration-300 rounded-md p-8 md:p-10">
              <span className="text-primary mb-4 text-6xl font-bold tracking-tighter md:text-7xl font-sans">
                <CountUp value={stat.value} isVisible={isVisible} />
              </span>
              <h3 className="text-foreground mb-3 text-xl font-bold md:text-2xl font-mono uppercase tracking-widest">
                {stat.label}
              </h3>
              <p className="text-muted-foreground text-base leading-relaxed font-sans">
                {stat.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}